import { firmCompGroupsUrl, firmRequestsUrl, firmSettingsUrl, firmSummaryUrl, firmUserManagementUrl, firmWaterfallUrl } from 'common/config/urls';
import { PROCESS_MANAGEMENT_ENABLER } from 'common/constants/features';
import { FIRM_REQUESTS_SLUG, FIRM_SETTINGS_SLUG, REQUESTS } from 'common/constants/firms';
import { FIRM_WATERFALL, FIRM_WATERFALL_PAGE_TITLE, USER_MANAGEMENT_PAGE_TITLE, USER_MANAGEMENT_TAB } from 'common/constants/user';
import { ApplicationMenuRoute } from 'common/types/urlRoutes/applicationMenuRoute';

export const FIRM_ROUTES: ApplicationMenuRoute[] = [
  {
    id: 'summary',
    route: firmSummaryUrl,
    hidden: false,
    slug: 'summary',
    title: 'Summary',
    itemKey: 0,
  },
  {
    id: 'edit-firm',
    route: firmSettingsUrl,
    hidden: false,
    slug: FIRM_SETTINGS_SLUG,
    title: 'Settings',
    itemKey: 1,
  },
  {
    id: 'comp-groups',
    route: firmCompGroupsUrl,
    hidden: false,
    slug: 'comp-groups',
    title: 'Comp Groups',
    itemKey: 2,
  },
  {
    id: USER_MANAGEMENT_TAB,
    route: firmUserManagementUrl,
    hidden: false,
    slug: USER_MANAGEMENT_TAB,
    title: USER_MANAGEMENT_PAGE_TITLE,
    itemKey: 3,
  },
  {
    id: REQUESTS.toLowerCase(),
    route: firmRequestsUrl,
    hidden: false,
    slug: FIRM_REQUESTS_SLUG,
    title: REQUESTS,
    featureFlag: PROCESS_MANAGEMENT_ENABLER,
    itemKey: 4,
  },
  {
    id: FIRM_WATERFALL,
    route: firmWaterfallUrl,
    hidden: false,
    slug: FIRM_WATERFALL,
    title: FIRM_WATERFALL_PAGE_TITLE,
    itemKey: 5,
  },
];